import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { queryStringToDictionary } from '../../../helpers/routeHelpers';
import { TARGET_ANCHOR_KEY } from '../config';
import style from '../Information.module.scss';


export const useInitAnchorScrollTo = () => {
    const location = useLocation();

    const initRef = useRef(false);
    const prefRef = useRef('');
    useLayoutEffect(() => {
        if (initRef.current) return;
        initRef.current = true;
        if (prefRef.current === location.hash) return;

        setTimeout(() => {
            const hashString = queryStringToDictionary(location.hash);
            const id = hashString[TARGET_ANCHOR_KEY];
            if (!id) return;

            const element = document.getElementById(id);
            element?.classList.add(style['highlighted']);
            prefRef.current = location.hash;

            if (!element) return;
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }, 100);

        return () => {
            const element = document.querySelector(`.${style['highlighted']}`);
            element?.classList.remove(style['highlighted']);
        };
    }, [location]);
};
